import React, { useState, useEffect } from "react";
import BredCrumb from "./BredCrumb";
import { axiosBaseURLExternal } from "../../httpCommon";
import InternalBaseBanner from "./InternalBaseBanner";
import { useTitle } from "../../services/PageTitle";

const Tender = () => {
  useTitle("Tender");
  const [loading, setLoading] = useState(false);
  const [showArchive, setShowArchive] = useState(false);

  const [drtLocations, setDrtLocations] = useState([]);
  const [tenderList, setTenderList] = useState([]);
  const [drtDratLocationName, setDrtDratLocationName] = useState(
    "DEBTS RECOVERY TRIBUNAL DELHI(DRT 1)"
  );

  const fetchDrtLocations = async () => {
    try {
      const res = await axiosBaseURLExternal.post("getDrtDratScheamName");
      setDrtLocations(res.data);
    } catch (error) {
      setDrtLocations([]);
    }
  };

  const fetchTenderList = async (data) => {
    try {
      setLoading(true);
      const res = await axiosBaseURLExternal.post("getTenderNotice", data);
      setTenderList(
        res.data.map((item, index) => ({ ...item, sr: index + 1 }))
      );
    } catch (error) {
      setTenderList([]);
    } finally {
      setLoading(false);
    }
  };

  const getDrtDratName = (id) => {
    const name = drtLocations.find((item) => item.schemeNameDrtId === id);
    if (name) setDrtDratLocationName(name.SchemaName);
  };

  useEffect(() => {
    fetchDrtLocations();
    fetchTenderList({ schemeNameDrtId: "1" });
  }, []);

  return (
    <div>
      <InternalBaseBanner title="Tender" />
      <BredCrumb title="Tender" />

      <div className="common-bg">
        <div className="container">
          {/* Header Section */}
          <div className="row">
            <div className="col-12 col-sm-12 col-md-12 col-lg-6">
              <div className="about-content">
                <h6>Tender</h6>
              </div>
            </div>

            {/* Dropdown Section */}
            <div className="col-12 col-sm-12 col-md-12 col-lg-6 mt-4">
              <div className="ml-auto">
                <label
                  htmlFor="tenderLocation"
                  className="sr-only"
                >
                  Select DRAT/DRT Location
                </label>
                <select
                  id="tenderLocation"
                  className="form-control"
                  aria-label="Select DRAT or DRT location"
                  onChange={(e) => {
                    const data = { schemeNameDrtId: e.target.value };
                    fetchTenderList(data);
                    getDrtDratName(e.target.value);
                  }}
                  defaultValue=""
                >
                  <option value="" disabled>
                    Select DRAT/DRT Location
                  </option>
                  {drtLocations.map((item, index) => (
                    <option value={item.schemeNameDrtId} key={index}>
                      {item.SchemaName}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>

          {/* Table Section */}
          <div className="row">
            <div className="col-12">
              <button
                className="btn btn-warning mb-3"
                onClick={() => setShowArchive(!showArchive)}
                aria-pressed={showArchive}
                aria-label={
                  showArchive
                    ? "Show last 12 months Notices"
                    : "Show archive"
                }
              >
                {showArchive
                  ? "Show last 12 months Notices"
                  : "Show Archive"}
              </button>

              <div className="table-responsive">
                <table
                  className="table table-striped common-table bluetable"
                  aria-label="Tender Notices Table"
                >
                  <thead>
                    <tr>
                      <th scope="col">Sl. No.</th>
                      <th scope="col">DRT Name</th>
                      <th scope="col">Summary</th>
                      <th scope="col">Document</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      <tr>
                        <td colSpan="4">
                          <h6 className="loader">Loading ...</h6>
                        </td>
                      </tr>
                    ) : tenderList && tenderList.length > 0 ? (
                      tenderList.map((item, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{drtDratLocationName}</td>
                          <td>{item.massage}</td>
                          <td>
                            <a
                              href={item.auctionurl}
                              target="_blank"
                              rel="noopener noreferrer"
                              aria-label={`Open tender document for ${drtDratLocationName}`}
                            >
                              <i
                                className="fas fa-file-pdf"
                                aria-hidden="true"
                              ></i>
                              <span className="sr-only">
                                View Tender Document
                              </span>
                            </a>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="4">
                          <strong>No Data Found. Select DRAT/DRT.</strong>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Tender;
